import React, { Component } from 'react'
import { Form, DatePicker, Select } from 'formik-antd'
// import enGB from 'antd/lib/locale-provider/en_GB'
import { Formik, ErrorMessage } from 'formik'
import moment from 'moment'
import _ from 'lodash'
import 'moment/locale/en-gb'
import { saveAs } from 'file-saver'
// import 'antd/dist/antd.css'
import validate from './validation'
import getValidationSchema from './validationSchema'
import httpClient from '../../utils/http'

const { Option } = Select
const periodDefault = 'weekly'

moment.locale('en-nz')

const rangeTypes = {
    WEEKLY: 'weekly',
    CUSTOM: 'custom',
}

export default class MyRoster extends Component {
    state = {
        visible: false,
        displayLabel: '',
        current: moment(new Date()),
        dateFrom: '',
        dateTo: '',
        reportType: 'all',
        startValue: null,
        endValue: null,
        endOpen: false,
        selectedPeriod: 'weekly',
    }

    handleChange = option => {
        this.setState({ selectedPeriod: option })
    }

    handleVisibleChange = visible => {
        this.setState({ visible })
    }

    disabledStartDate = startValue => {
        const { endValue } = this.state
        if (!startValue || !endValue) {
            return false
        }
        return startValue.valueOf() > endValue.valueOf()
    }

    disabledEndDate = endValue => {
        const { startValue } = this.state
        if (!endValue || !startValue) {
            return false
        }
        return endValue.valueOf() <= startValue.valueOf()
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        })
    }

    onStartChange = (values, form) => {
        // console.log();
        this.onChange('startValue', values)
    }

    onEndChange = value => {
        this.onChange('endValue', value)
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true })
        }
    }

    handleEndOpenChange = open => {
        this.setState({ endOpen: open })
    }

    createAndDownloadPdf = (data, setSubmitting) => {
        const user = JSON.parse(localStorage.getItem('user'))
        const userId = user.userId

        const url = `/api/report/get-pdf/${userId}`;
        
        // fetch(`/api/report/get-pdf/${userId}`, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        //     method: 'POST',
        // })
        httpClient
            .post(url, data)
            .then(res => {
                return res.arrayBuffer().then(res => {
                    const pdfBlob = new Blob([res], { type: 'application/pdf' })
                    const fileURL = URL.createObjectURL(pdfBlob)
                    window.open(fileURL)
                })
            })
            .catch(error => {
                console.log(`error=${error}`)
            })
            .then(() => {
                setSubmitting(false)
            })
    }

    createAndDownloadExcel = (data, setSubmitting) => {
        const user = JSON.parse(localStorage.getItem('user'))
        const userId = user.userId

        const url = `/api/report/get-excel/${userId}`;

        // fetch(`/api/report/get-excel/${employeeId}`, {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        //     method: 'POST',
        //     responseType: 'arraybuffer',
        // })
        httpClient
            .post(url, data)
            .then(res => {
                return res.arrayBuffer().then(res => {
                    var blob = new Blob([res], {
                        type:
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    })
                    saveAs(blob, 'Report.xlsx')
                })
            })
            .catch(error => {
                console.log(`error=${error}`)
            })
            .then(() => {
                setSubmitting(false)
            })
    }

    handleFormSubmit = (data, setSubmitting) => {
        const { period, week, range, rptType } = data

        let startOfWeek = moment(week).startOf('isoweek')
        let endOfWeek = moment(week).endOf('isoweek')

        if (period === rangeTypes.CUSTOM) {
            startOfWeek = _.head(range)
            endOfWeek = _.last(range)
        }

        const bodyData = {
            range: 'any',
            start: startOfWeek,
            end: endOfWeek,
            type: rptType,
        }

        switch (rptType) {
            case 'pdf':
                {
                    this.createAndDownloadPdf(bodyData, setSubmitting)
                }
                break

            case 'excel':
                {
                    this.createAndDownloadExcel(bodyData, setSubmitting)
                }
                break
            default: {
                console.log(`error=no report type specified`)
            }
        }
    }

    render() {
        const today = new Date()
        const startDate = moment(today).startOf('isoweek')
        const endDate = moment(today).endOf('isoweek')

        const { selectedPeriod } = this.state

        return (
            <div>
                <Formik
                    initialValues={{
                        range: [startDate, endDate],
                        period: periodDefault,
                        rptType: 'pdf',
                        week: moment(today),
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            this.handleFormSubmit(values, setSubmitting)
                        }, 400)
                    }}
                >
                    {({ values, handleSubmit, isSubmitting }) => (
                        <Form onSubmit={handleSubmit}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="panel">
                                            <div className="panel-heading">
                                                <h3 className="panel-title">
                                                    Reports
                                                </h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <div className="col-sm-6 reportToolBar">
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-success pull-left btn-md-w"
                                                                    disabled={
                                                                        isSubmitting
                                                                    }
                                                                >
                                                                    Export
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row"></div>

                                                    <div className="row form-group">
                                                        <div className="col-sm-2 col-md-2 padright15">
                                                            <div className="form-group">
                                                                <label
                                                                    htmlFor="period"
                                                                    className="control-label"
                                                                >
                                                                    Period
                                                                </label>
                                                                <Select
                                                                    name="period"
                                                                    readOnly
                                                                    placeholder="Select Report Period"
                                                                    className="form-control"
                                                                    defaultValue={
                                                                        'weekly'
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleChange
                                                                    }
                                                                >
                                                                    <Option value="weekly">
                                                                        Weekly
                                                                    </Option>
                                                                    <Option value="custom">
                                                                        Custom
                                                                    </Option>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <div className="col-sm-10 col-md-10 padright15">
                                                            {selectedPeriod ===
                                                                rangeTypes.WEEKLY && (
                                                                <DatePicker
                                                                    name="week"
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    inputReadOnly={
                                                                        true
                                                                    }
                                                                    // locale={
                                                                    //     enGB
                                                                    // }
                                                                />
                                                            )}
                                                            {selectedPeriod ===
                                                                rangeTypes.CUSTOM && (
                                                                <DatePicker.RangePicker
                                                                    inputReadOnly={
                                                                        true
                                                                    }
                                                                    name="range"
                                                                    // locale={
                                                                    //     enGB
                                                                    // }
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <div className="col-sm-2 col-md-2 padright15">
                                                            <label
                                                                htmlFor="rptType"
                                                                className="control-label"
                                                            >
                                                                Report Type
                                                            </label>
                                                            <Select
                                                                name="rptType"
                                                                defaultValue={
                                                                    values.rptType
                                                                }
                                                                readOnly
                                                                placeholder="Select Report Type"
                                                                className="form-control"
                                                            >
                                                                <Option value="pdf">
                                                                    PDF
                                                                </Option>
                                                                <Option value="excel">
                                                                    Excel
                                                                </Option>
                                                            </Select>
                                                        </div>
                                                    </div>

                                                    <div className="errorMsg">
                                                        <ErrorMessage name="start" />
                                                        <br />
                                                        <ErrorMessage name="end" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}
